import { TFunction } from "i18next";
import * as yup from "yup";
import { ValidationMessagesUtils } from "../../../utils/yup";

export default function createRosterSchema(t: TFunction) {
  return yup.object().shape({
    reference: yup
      .string()
      .required(
        ValidationMessagesUtils.createRequiredMessage(t, "common.reference")
      ),
    date: yup
      .string()
      .required(
        ValidationMessagesUtils.createRequiredMessage(t, "common.date")
      ),
    deliveryInstructions: yup.string(),

    items: yup.array().of(
      yup.object().shape({
        name: yup
          .string()
          .required(
            ValidationMessagesUtils.createRequiredMessage(
              t,
              "common.description"
            )
          ),
        quantity: yup
          .number()
          .required(
            ValidationMessagesUtils.createRequiredMessage(t, "costing.quantity")
          ),
        cost: yup
          .number()
          .required(
            ValidationMessagesUtils.createRequiredMessage(t, "costing.cost")
          ),
        UOM: yup
          .string()
          .required(
            ValidationMessagesUtils.createRequiredMessage(t, "costing.uom")
          ),
      })
    ),
  });
}
